export let moviesList = ['Life Is Good', 'Maarrich', 'Salaam Venky', 'Shadow Assassins', 'India Lockdown', "Bhediya", "Drishyam 2"];
export let slots = ['10:00 AM', '01:00 PM', '03:00 PM', "08:00 PM", "11:30 PM"];
export let seats = ['A1', 'A2', 'A3', 'A4', 'D1', 'D2'];

// exports.moviesList = moviesList;
// exports.slots = slots;
// exports.seats = seats;
